module.exports = __webpack_public_path__ + "static/media/star.c3a82ad7.svg";